/**
 * Copyright (c) 2021 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __awaiter, __generator } from "tslib";
import { CustomPropertyDescriptor } from '../../mol-model/custom-property';
import { CustomModelProperty } from '../common/custom-model-property';
import { calcHelixOrientation } from './helix-orientation/helix-orientation';
export var HelixOrientationParams = {};
export var HelixOrientationProvider = CustomModelProperty.createProvider({
    label: 'Helix Orientation',
    descriptor: CustomPropertyDescriptor({
        name: 'molstar_helix_orientation'
    }),
    type: 'dynamic',
    defaultParams: {},
    getParams: function () { return ({}); },
    isApplicable: function (data) { return true; },
    obtain: function (ctx, data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, { value: calcHelixOrientation(data) }];
        });
    }); }
});
//# sourceMappingURL=helix-orientation.js.map